document.addEventListener('DOMContentLoaded', function() {
  const tabNames = document.querySelectorAll('.skineft-tabname');
  const contents = document.querySelectorAll('.skineft-content');

  tabNames.forEach(function(tab) {
    tab.addEventListener('click', function() {
      tabNames.forEach(function(otherTab) {
        otherTab.classList.remove('active');
      });
      this.classList.add('active');

      const tabId = this.getAttribute('data-tab');

      contents.forEach(function(content) {
        content.classList.remove('active');
      });
      const activeContent = document.querySelector(`.skineft-content#${tabId}`);
      if (activeContent) {
        activeContent.classList.add('active');
      }
    });
  });
});